let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dEYJH")).then(() => parcelRequire('dxG8U'));